export default (theme) => ({
	hero: {
		position: "relative",
		zIndex: 2,
		height: 610,
		background: "#353535",
		width: "100%",
		[theme.breakpoints.down("xs")]: {
			height: 200,
		},
	},
	picture: {
		opacity: ".7",
		position: "absolute",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center center",
		backgroundSize: "cover",
		left: 0,
		top: 0,
		right: 0,
		bottom: 0,
		transition: "all .4s",
		[theme.breakpoints.down("xs")]: {
			opacity: ".7",
		},
	},
	pictureGradient: {
		background: "linear-gradient(1turn,rgba(0,0,0,.55) 25%,transparent 50%)",
	},
	backgroundImage: {
		position: "relative",
		width: "100%",
		overflow: "hidden",
		objectFit: "cover",
		objectPosition: "center center",
		display: "block",
		height: "100%",
	},
	heroBox: {
		[theme.breakpoints.up("sm")]: {
			"position": "absolute",
			"-webkit-transform": "translateY(-50%)",
			"transform": "translateY(-50%)",
		},
		[theme.breakpoints.down("xs")]: {
			position: "relative",
		},
	},
	h1: {
		fontSize: 28,
		fontWeight: 700,
		lineHeight: 1.25,
		margin: 0,
		textShadow: "rgb(67 67 67) 2px 2px 5px",
	},
	floatingText: {
		fontSize: 14,
		fontWeight: 600,
		width: 250,
	},
	//FOR CATEGORY
	wrapper: {
		height: 600,
		maxHeight: 880,
		//background: "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQzIiBoZWlnaHQ9IjI0OCIgdmlld0JveD0iMCAwIDE0NDMgMjQ4IiBzdHlsZT0iYmFja2dyb3VuZDogI0YzRjNGNDsiPgogICAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjE0NDMiIGhlaWdodD0iMjQ3IiBmaWxsPSIjQzNEOUY5IiAvPgogICAgPGcgZmlsbD0iI0YzRjNGNCIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNLTgtOWgzNTN2MTU2SC04eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0zNDguNjA0LTYuNTYzQzgwLjEzMy0zNi4zNC0xNDAuMzEyIDIxMC4zOTgtMTE1LjAyIDUzMy40MmMyNS41NyAzMjYuNTY2IDMwMi40NDMgNTc2LjM5MiA3MzYuODgzIDU3Ni4zOTIgNjU2Ljc1OCAwIDkzOS44OTItNjgwLjMyNCA4MTMuNjQ1LTg5NC44NTgtMTYxLjg4Mi0yNzUuMDg2LTQ0NC4zNjggMy44NzUtNjExLjUzMS0yNS43NzNDNjU2LjgxNCAxNTkuNTMgNjE3LjA3NiAyMy4yMTQgMzQ4LjYwNC02LjU2M3oiLz4KICAgIDwvZz4KPC9zdmc+Cg==) right top / 1190px no-repeat rgb(243, 243, 244)",
		background:
			"url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQzIiBoZWlnaHQ9IjI0OCIgdmlld0JveD0iMCAwIDE0NDMgMjQ4IiBzdHlsZT0iYmFja2dyb3VuZDogI0ZGRkZGRjsiPgogICAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjE0NDMiIGhlaWdodD0iMjQ3IiBmaWxsPSIjQzNEOUY5IiAvPgogICAgPGcgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNLTgtOWgzNTN2MTU2SC04eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0zNDguNjA0LTYuNTYzQzgwLjEzMy0zNi4zNC0xNDAuMzEyIDIxMC4zOTgtMTE1LjAyIDUzMy40MmMyNS41NyAzMjYuNTY2IDMwMi40NDMgNTc2LjM5MiA3MzYuODgzIDU3Ni4zOTIgNjU2Ljc1OCAwIDkzOS44OTItNjgwLjMyNCA4MTMuNjQ1LTg5NC44NTgtMTYxLjg4Mi0yNzUuMDg2LTQ0NC4zNjggMy44NzUtNjExLjUzMS0yNS43NzNDNjU2LjgxNCAxNTkuNTMgNjE3LjA3NiAyMy4yMTQgMzQ4LjYwNC02LjU2M3oiLz4KICAgIDwvZz4KPC9zdmc+Cg==) right top / 1190px no-repeat rgb(255, 255, 255)",
		[theme.breakpoints.down("xs")]: {
			height: "auto",
			minHeight: 540,
			display: "flex",
			alignItems: "center",
			background: "#FFF",
		},
		position: "relative",
		zIndex: 2,
		width: "100%",
	},
	mainH1: {
		fontSize: 48,
		lineHeight: "56px",
		[theme.breakpoints.down("sm")]: {
			fontSize: 44,
			lineHeight: "52px",
		},
		[theme.breakpoints.down("xs")]: {
			fontSize: 28,
			lineHeight: "36px",
		},
		fontWeight: 700,
		textAlign: "left",
		marginTop: 0,
		marginBottom: "16px",
	},
	quick: {
		fontWeight: 700,
		[theme.breakpoints.down("xs")]: {
			marginBottom: "12px",
		},
	},
	flexCenter: {
		[theme.breakpoints.down("xs")]: {
			flexDirection: "column",
		},
	},
	proSection: {
		minHeight: "100vh",
		width: "100%",
		paddingTop: 40,
		paddingBottom: 44,
		paddingRight: 8,
		paddingLeft: 8,
	},
	proSectionVerifiedIcon: {
		width: 26,
		[theme.breakpoints.down("xs")]: {
			marginTop: 2,
		},
	},
	proSectionH2: {
		fontSize: 26,
		fontWeight: 600,
		lineHeight: 1.3,
		marginTop: 0,
		marginBottom: 0,
		marginLeft: 6,
		[theme.breakpoints.down("xs")]: {
			fontSize: 22,
		},
	},
	proSectionSubHeader: {
		color: theme.palette.grey[700],
		marginTop: 8,
		lineHeight: 1.5,
		fontSize: 16,
	},
	reviewsSection: {
		margin: "8px 8px 48px",
	},
	reviewsH2: {
		fontSize: 26,
		fontWeight: 600,
		lineHeight: 1.3,
		marginBottom: 8,
	},
	reviewsBox: {
		display: "flex",
		flexDirection: "column",
		borderRadius: 12,
		border: "1px solid #ddd",
		padding: 32,
		height: "100%",
	},
	reviewsAuthor: {
		fontWeight: 600,
		marginBottom: 8,
	},
	reviewsBody: {
		"fontSize": 14,
		"color": theme.palette.grey[700],
		"lineHeight": 1.5,
		"margin": "12px 0px",
		"display": "-webkit-box",
		"maxHeight": 230,
		"overflow": "hidden",
		"textOverflow": "ellipsis",
		"-webkit-box-orient": "vertical",
		"-webkit-line-clamp": 8,
	},
	reviewsCompany: {
		display: "flex",
		alignItems: "center",
	},
	reviewsCompanyName: {
		"marginLeft": 8,
		"fontSize": 14,
		"display": "-webkit-box",
		"overflow": "hidden",
		"textOverflow": "ellipsis",
		"-webkit-box-orient": "vertical",
		"-webkit-line-clamp": 2,
	},
});
